import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import * as moment from 'moment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';

@Injectable()
export class AuthService {

  refreshing = false;

  constructor(
    private http: HttpClient,
    private roleService: NgxRolesService,
    private permissionService: NgxPermissionsService
  ) { }

  login(username: string, password: string, role: string) {
    const credentials = { username: username, password: password, role: role };
    console.log('AuthService:login credentials', credentials);
    return this.http.post<any>('/api/auth/login', credentials).map(res => {
      localStorage.setItem('user', JSON.stringify(res.user));
      localStorage.setItem('role', res.role);
      localStorage.setItem('token', res.token);
      localStorage.setItem('expiration', res.expiration);
      this.loadRoles();
    });
  }

  loadRoles() {
    this.roleService.flushRoles();
    this.permissionService.flushPermissions();
    this.permissionService.loadPermissions([]);
    if (this.isLoggedIn) {
      const user = this.getUser();
      const role = this.getRole();
      this.roleService.addRole(role, []);
      if (role === 'ROLE_ADMIN' && user.isSuperAdmin) {
        this.roleService.addRole('ROLE_SUPER_ADMIN', []);
      }
      console.log(user);
      console.log('user.pack' + user.pack);
      if ((role === 'ROLE_SUPER_CLIENT' || role ===  'ROLE_CLIENT' || role ===  'ROLE_RESPONSIBLE') && user.pack === '1' ) {
        this.roleService.addRole('ROLE_PACK_START', []);
        console.log('ROLE_PACK_START');
      }
      if ((role === 'ROLE_SUPER_CLIENT' || role ===  'ROLE_CLIENT' || role ===  'ROLE_RESPONSIBLE') && user.pack === '2' ) {
        this.roleService.addRole('ROLE_PACK_ESSENTIEL', []);
        console.log('ROLE_PACK_ESSENTIEL');
      }
      if ((role === 'ROLE_SUPER_CLIENT' || role ===  'ROLE_CLIENT' || role ===  'ROLE_RESPONSIBLE') && user.pack === '3' ) {
        this.roleService.addRole('ROLE_PACK_PRO', []);
        console.log('ROLE_PACK_PRO');
      }
      console.log(this.roleService);
    }
  }

  logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('role');
    localStorage.removeItem('token');
    localStorage.removeItem('expiration');
    this.roleService.flushRoles();
  }

  public get isLoggedIn() {
    return localStorage.getItem('user') && moment().isBefore(this.getExpiration());
  }

  isLoggedOut() {
    const isLoggedOut = !this.isLoggedIn;
    return isLoggedOut;
  }

  getUser() {
    return JSON.parse(localStorage.getItem('user'));
  }

  getRole() {
    return localStorage.getItem('role');
  }

  getToken() {
    return localStorage.getItem('token');
  }

  getExpiration() {
    const expiration = localStorage.getItem('expiration') || '';
    return moment(parseInt(expiration, 10) * 1000);
  }

  isRefreshTokenRequired() {
    return this.isLoggedIn &&
      this.getExpiration().isBefore(moment().add(1, 'hours'));
  }

  refreshToken(force = false) {
    if (this.refreshing != true) {
      this.refreshing = true;
      return this.http.post<any>('/api/auth/token_refresh', {})
        .subscribe(
          res => {
            localStorage.setItem('token', res.token);
            localStorage.setItem('expiration', res.expiration);
            this.refreshing = false;
          },
          err => {
            this.refreshing = false;
            return Observable.throw(err);
          });
    } else {
    }
  }

  switchToSuperClient(clientId) {
    let promise = new Promise((resolve, reject) => {
      const role = this.getRole();
      if (role === 'ROLE_ADMIN') {
        this.http.post<any>('/api/auth/role_switch', { clientId: clientId })
          .subscribe(
            res => {
              localStorage.setItem('admin', localStorage.getItem('user'));
              localStorage.setItem('user', JSON.stringify(res.user));
              localStorage.setItem('role', 'ROLE_SUPER_CLIENT');
              localStorage.setItem('token', res.token);
              localStorage.setItem('expiration', res.expiration);
              this.loadRoles();
              resolve();
            },
            err => {
              reject();
              // return Observable.throw(err);
            });
      } else {
        reject();
      }
    });
    return promise;
  }

  switchToAdmin() {
    let promise = new Promise((resolve, reject) => {
      const role = this.getRole();
      if (role === 'ROLE_SUPER_CLIENT') {
        const admin = JSON.parse(localStorage.getItem('admin'));
        this.http.post<any>('/api/auth/role_switch', { adminId: admin.id })
          .subscribe(
            res => {
              localStorage.setItem('user', localStorage.getItem('admin'));
              // localStorage.setItem('user', JSON.stringify(res.user));
              localStorage.setItem('role', 'ROLE_ADMIN');
              localStorage.setItem('token', res.token);
              localStorage.setItem('expiration', res.expiration);
              this.loadRoles();
              resolve();
            },
            err => {
              reject();
              // return Observable.throw(err);
            });
      } else {
        reject();
      }
    });
    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts